import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  console.log(user, "this is user of private");

  const userAccountType = user?.agentDetail?.accountType || user?.accountType;
  const customerRole = user?.roleName || user?.roleData?.name;
  const userType = user?.user_type;

  console.log("Account Type:", userAccountType);
  console.log("Customer Role:", customerRole);
  console.log("User Type:", userType);

  let effectiveRole = customerRole || userAccountType || userType;

  if (userType === 'agent' && !userAccountType) {
    effectiveRole = 'merchant';
  }

  if (userType === 'business' || userType === 'retailer') {
    effectiveRole = userType;
  }

  console.log("Effective Role:", effectiveRole);

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (!user || (!userAccountType && !customerRole && !userType)) {
    console.log("User data incomplete, waiting...");
    return children ? children : <Outlet />;
  }

  if (!allowedRoles) {
    return children ? children : <Outlet />;
  }

  const hasAllowedRole = allowedRoles.some(role => {
    return effectiveRole?.toLowerCase() === role.toLowerCase();
  });

  if (!hasAllowedRole) {
    console.log(`Access denied. User role: ${effectiveRole}, Allowed: ${allowedRoles}`);

    if (effectiveRole === "b2c" || effectiveRole === "customer" || effectiveRole === "normal") {
      return <Navigate to="/Customer-dashboard" replace />;
    } else if (effectiveRole === "retailer") {
      return <Navigate to="/retailer-dashboard" replace />;
    } else if (effectiveRole === "business") {
      return <Navigate to="/business-dashboard" replace />;
    } else {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;